import PromotionCodes from "./PromotionCodes";
import { connect } from 'react-redux';
import * as promotionAction from "../../../../../../actions/promotionAction";

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        parseExcel: (file) => dispatch(promotionAction.parseExcel(file)),
        parseExcelClearData: () => dispatch(promotionAction.parseExcelClearData()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionCodes);
